/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-btn.vue?vue&type=template&id=dbca018c&scoped=true&"
import script from "./edit-btn.vue?vue&type=script&lang=ts&"
export * from "./edit-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbca018c",
  null
  
)

export default component.exports